import styled, { css } from 'styled-components';
import common from '../../../styles/common';
import { BsCheck } from 'react-icons/bs';
import { IoClose } from 'react-icons/io5';
import Button from '../../Button';

export const Wrapper = styled.div`
  display: flex;
`;

export const NameWrapper = styled.div``;

export const Name = styled.h2`
  margin: 0 0.5rem 0.25rem 0;
`;

export const BigInput = styled.input`
  ${common.input}
  width: 250px;
  font-size: 1rem;
  font-weight: 600;
`;

export const NormalInput = styled.input`
  ${common.input}
  width: 175px;
  font-size: 0.875rem;
  font-weight: 500;
`;

const infoTextCommon = css`
  font-size: 1.2rem;
  font-weight: 500;
  opacity: 0.8;
  margin-bottom: 0;
`;

export const InfoText = styled.p`
  ${infoTextCommon}
  margin-top: 0.25rem;
`;

export const PhaseWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-left: 1.25rem;
`;

export const PhaseText = styled.p`
  ${infoTextCommon}
`;

export const BtnsWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-left: 1.25rem;
`;

export const SaveBtn = styled(Button).attrs(({ wrapperStyle = {} }) => ({
  wrapperStyle: {
    width: 'auto',
    height: 'auto',
    marginLeft: '0.5rem',
    ...wrapperStyle,
  },
  type: 'transparentBackgroundButton',
  icon: BsCheck,
  iconProps: {
    strokeWidth: '1.5',
    color: 'green',
    // fill: 'green',
    size: '1.6rem',
  },
}))``;

export const CancelBtn = styled(Button).attrs(({ wrapperStyle = {} }) => ({
  wrapperStyle: {
    width: 'auto',
    height: 'auto',
    marginLeft: '1rem',
    ...wrapperStyle,
  },
  type: 'transparentBackgroundButton',
  icon: IoClose,
  iconProps: {
    strokeWidth: '1.5',
    color: 'red',
    // fill: 'green',
    size: '2rem',
  },
}))``;

export const ProjectWrapper = styled.div`
  display: flex;
  align-items: center;
`;
